import React, { Suspense, lazy } from 'react';
import { Switch, Redirect } from 'react-router-dom';

import Route from './Route';
import Loader from '../components/Loader';
import SuperLogin from '../pages/SuperLogin';

const AddMechanics = lazy(() => import('../pages/Onboarding/AddMechanics'));
const Appointments = lazy(() => import('../pages/appointments'));
const QuickCheckout = lazy(() => import('../pages/QuickCheckout'));
const Purchases = lazy(() => import('../pages/Purchases'));
// const BlockList = lazy(
//   () => import('../pages/Dashboard/Components/BlockList/Blocklist'),
// eslint-disable-next-line function-paren-newline
// );
// const Estimator = lazy(() => import('../pages/Estimator'));
const Estimator = lazy(() => import('../pages/Estimator2'));
const ForgotPassword = lazy(() => import('../pages/auth/ForgetPassword'));
const Gamification = lazy(
  () => import('../components/Gamification/Gamification'),
  // eslint-disable-next-line function-paren-newline
);

const JobBoard = lazy(() => import('../pages/JobBoard'));
const Listing = lazy(() => import('../pages/listing'));
const Inventory = lazy(() => import('../pages/Inventory'));
// // import Mechanic from '../pages/mechanic';
const NotFound = lazy(() => import('../pages/NotFound/NotFound'));

const PdfPreview = lazy(() => import('../components/PDFs/SalesTaxReport'));
const Campaigner = lazy(() => import('../pages/Campaigner'));
const Communication = lazy(() => import('../pages/Communication'));
const CampaignReview = lazy(() => import('../pages/CampaignReview'));
const Notification = lazy(() => import('../pages/Notifcation'));
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'));
const SignIn = lazy(() => import('../pages/auth/SignIn'));
const SignUp = lazy(() => import('../pages/auth/Signup'));
const Settings = lazy(() => import('../pages/Settings'));
const SetupAccount = lazy(() => import('../pages/Onboarding/SetupAccount'));
const UnderConstruction = lazy(
  () => import('../pages/NotFound/UnderConstruction'),
  // eslint-disable-next-line function-paren-newline
);
const Reports = lazy(() => import('../pages/reports'));
const NewRepairOrder = lazy(() => import('../pages/NewRepairOrder'));
const ViewRepairOrder = lazy(() => import('../pages/ViewRepairorder'));
const ViewRo = lazy(() => import('../pages/viewRo'));
const ViewEstimate = lazy(() => import('../components/ViewEstimate'));

const Dashboard = lazy(() => import('../pages/Dashboard'));

// -=======new msgs cont socket====
// success case of send sms or email to customer

const Routes = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route
          path='/superLogin'
          name='superLogin'
          exact
          component={SuperLogin}
        />
        <Route
          path='/team'
          name='team'
          exact
          isPrivate
          component={AddMechanics}
        />
        <Route
          path='/appointments'
          name='appointments'
          isPrivate
          exact
          component={Appointments}
        />
        <Route
          path='/quickcheckout'
          name='quickcheckout'
          isPrivate
          exact
          component={QuickCheckout}
        />
        <Route
          path='/campaigner'
          name='campaigner'
          isPrivate
          exact
          component={Campaigner}
        />{' '}
        <Route
          path='/communication'
          name='communication'
          isPrivate
          exact
          component={Communication}
        />
        <Route
          path='/purchases'
          name='purchases'
          isPrivate
          exact
          component={Purchases}
        />
        <Route
          path='/campaign-template'
          name='campaign'
          isPrivate
          exact
          component={CampaignReview}
        />
        <Route
          path='/inventory'
          name='inventory'
          isPrivate
          exact
          component={Inventory}
        />
        {/* <Route
        path='/blocklist'
        name='blocklist'
        isPrivate
        exact
        component={BlockList}
      /> */}
        <Route
          path='/dashboard'
          name='dashboard'
          isPrivate
          exact
          component={Dashboard}
        />
        {/* <Route
          path='/estimator2/:id?'
          name='estimator'
          isPrivate
          exact
          component={Estimator}
        /> */}
        <Route
          path='/estimator/:id?'
          name='estimator'
          isPrivate
          exact
          component={Estimator}
        />
        <Route path='/forgotpassword' exact component={ForgotPassword} />
        <Route path='/tutorial' exact isPrivate component={Gamification} />
        <Route
          path='/jobboard'
          name='jobboard'
          exact
          isPrivate
          component={JobBoard}
        />
        <Route
          path='/listing'
          name='listing'
          exact
          isPrivate
          component={Listing}
        />
        <Route
          path='/reports'
          name='reports'
          exact
          isPrivate
          component={Reports}
        />
        {/* <Route
        path='/mechanic'
        name='mechanicPortal'
        exact
        isPrivate
        component={Mechanic}
      /> */}
        <Route path='/notFound' exact component={NotFound} />
        <Route path='/pdfpreview' exact isPrivate component={PdfPreview} />
        <Route path='/notifications' exact isPrivate component={Notification} />
        <Route path='/resetpassword' exact component={ResetPassword} />
        <Route path='/signin' exact component={SignIn} />
        <Route path='/register-customer' exact component={SignUp} />
        <Route path='/setupaccount' verifiable exact component={SetupAccount} />
        <Route
          path='/settings'
          name='settings'
          exact
          isPrivate
          component={Settings}
        />
        <Route path='/underConstruction' exact component={UnderConstruction} />
        <Route
          path='/new-repairorder/:id'
          name='repairOrder'
          exact
          isPrivate
          component={NewRepairOrder}
        />
        <Route
          path='/view-repairorder/:publicKey'
          name='repairOrder'
          exact
          component={ViewRepairOrder}
        />
        <Route
          path='/view/repairorder/:publicKey/:authorizationHistoryId/:jobId'
          name='repairOrder'
          exact
          allowBoth
          component={ViewRo}
        />
        <Route
          path='/view/estimate/:publicKey/:authId'
          name='estimateView'
          exact
          allowBoth
          component={ViewEstimate}
        />
        <Route path='/' isPrivate exact />
        <Redirect to='/notFound' />
      </Switch>
    </Suspense>
  );
};
export default Routes;
